import { useRoomStore } from '@features/room';
import { ParticipantGrid } from '@widgets/ParticipantGrid';
import { RoomControls } from '@widgets/RoomControls';
import { RoomSettingsPanel } from './RoomSettingsPanel';
import { ParticipantsPanel } from '@/widgets/ParticipantsPanel/ParticipantsPanel';
import { RoomsListPanel } from '@widgets/RoomsListPanel';

export function StreamingPage() {
  const error = useRoomStore((s) => s.error);
  const connectionState = useRoomStore((s) => s.connectionState);

  return (
    <div className="grid h-full grid-cols-1 gap-5 overflow-y-auto p-5 xl:grid-cols-[minmax(0,1fr)_340px]">
      <section className="min-h-0 min-w-0 overflow-hidden rounded-lg border border-surface-border bg-surface-1 p-3">
        {connectionState !== 'connected' && error && (
          <div className="mb-3 rounded-lg border border-status-live/30 bg-status-live/10 px-4 py-3 text-sm text-status-live">
            {error}
          </div>
        )}
        <ParticipantGrid />
      </section>

      <aside className="min-h-0 min-w-0 space-y-5 overflow-y-auto xl:w-[340px]">
        <RoomControls />
        <RoomsListPanel onJoinRoom={(meeting) => useRoomStore.getState().joinExistingRoom(meeting)} />
        <ParticipantsPanel />
        <RoomSettingsPanel />
      </aside>
    </div>
  );
}